import { ComponentBread, ComponentHeader, StyledCreateLg, StyledCreateXl } from "@components";
import { PATH_DEPO_RECORDS, PATH_INVENTORY_CREATE, PATH_INVENTORY_MASTER } from "@configs";
import { IProduct } from "@interfaces";

import { setLoading } from "@redux";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router";
import { OrderForm } from "@modules";

export const PageSaleOrder = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [product, setProduct] = useState<IProduct>();
  useEffect(() => {
    if (id) {
      fetchProduct();
    }
  }, [id]);
  const data = [
    {
      title: <a href={PATH_INVENTORY_MASTER || ""}>{t("page.sale_order_list")}</a>,
    },
    {
      title: <a href={PATH_INVENTORY_CREATE || ""}>{t("page.add_new")}</a>,
    },
  ];
  const fetchProduct = async () => {
    try {
      dispatch(setLoading(true));
      await console.log("here fetc");
      //   const res = await healthApi.detail(id);
      //   setProduct(res.data);
    } catch (err: any) {
      history.push(PATH_DEPO_RECORDS);
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <>
      <ComponentHeader title={t("page.sale_order_form")} />
      <StyledCreateXl>
        <ComponentBread pages={data} />
        <OrderForm product={product} />
      </StyledCreateXl>
    </>
  );
};
